const { Type } = require('@sinclair/typebox');
const Blockly = require('blockly');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP =
    'Allows extracting data from a nested property, either a nested object, or a nested list. In the latter case, optionally filtering down to a specific list entry.';

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged horizontally (this is the default)
    //Meaning each (dummy)input continues on the top line followed by  the access modifiers
    blocklyBlock.setInputsInline(false);
    line1OfInputs.appendField('  Property Name:').appendField(new Blockly.FieldTextInput('title'), 'propertyName');
    blocklyBlock
        .appendDummyInput()
        .appendField('  Show All Values:')
        .appendField(new Blockly.FieldCheckbox('FALSE'), 'showAllValues');
    blocklyBlock
        .appendDummyInput()
        .appendField('  Values Are Strings:')
        .appendField(new Blockly.FieldCheckbox('FALSE'), 'showStringValues');

    //Statement inputs ALWAYS go on their own line.
    blocklyBlock.appendStatementInput('nestedColumnField').setCheck(['listColumn']).appendField('Nested Column Field:');

    // line 3, just text
    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_LEFT)
        .appendField('In case of an nested list, select the first entry');

    //Statement inputs ALWAYS go on their own line. (line 4)
    blocklyBlock
        .appendStatementInput('filters')
        .setCheck(['filter'])
        .appendField('(Optionally) Which matches all of these filters:');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties([
        'propertyName',
        { key: 'showAllValues', handler: value => value === 'TRUE' },
        { key: 'showStringValues', handler: value => value === 'TRUE' },
        {
            key: 'sequence',
            // Song and dance to figure out the sequence based on order in the workspace.
            handler: () => {
                const parent = blocklyBlock.getSurroundParent();
                const parentChildren = parent.getDescendants(false);
                return parentChildren.findIndex(value => value.id === blocklyBlock.id) - 1; // subtract 1 because includes parent with getDescendants
            }
        }
    ]);
    code.label = code.title;
    code.dataType = 'nestedDetail';
    //nested blocks in the statements are added automatically by blockly
    return code;
}

/** Builds the data dictionary fragment for the NestedDetail list column. */
function asDataDictionary(hNode, context) {
    const { propertyName, children, showAllValues, showStringValues } = hNode;
    //let's find out what the children define....
    let [childDefinedSubDataDictionary = {}, childDefinedPartialTypeDefinition = {}] = children?.reduce(
        ([sdd, ptd], child) => {
            const [_subDataDictionary = {}, _partialTypeDefinition = {}] = context.extractFromChild(child, context);
            return [
                merge(sdd, _subDataDictionary),
                moduleRegistration.mergePartialTypeDefinitions(ptd, _partialTypeDefinition)
            ];
        },
        [{}, {}]
    ) ?? [{}, {}];

    const isArray = showStringValues === true || showAllValues === true || (children || []).some(child => child.hNodeTypeGroup === 'filter');
    const propertySchema = isArray
        ? Type.Array(
              showStringValues === true
                  ? Type.String({ title: 'Item', 'x-dataType': 'string' })
                  : Type.Object(childDefinedPartialTypeDefinition, {
                        title: 'Item',
                        'x-dataType': 'object',
                        additionalProperties: true
                    }),
              {
                  'x-dataType': 'array',
                  'x-propertyName': propertyName
              }
          )
        : Type.Object(childDefinedPartialTypeDefinition, {
              'x-dataType': 'object',
              'x-propertyName': propertyName,
              additionalProperties: true
          });

    //we know whatever partials the children defined, are nested in our property
    const partialTypeDefinition = {
        [propertyName]: propertySchema
    };

    //And the given foreignKey exists on the parent object.
    return [childDefinedSubDataDictionary, partialTypeDefinition];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
